import { FC } from "react";
import { useTranslation } from "react-i18next";
import { styled, Typography } from "@mui/material";

const Container = styled("div")(() => ({
  right: 0,
  width: "242px",
  bottom: "20px",
  padding: "16px",
  marginRight: "8px",
  position: "absolute",
  backgroundColor: "white"
}));

type ConvoyStatusGuideProps = {
  total: number;
};

const ConvoyStatusGuide: FC<ConvoyStatusGuideProps> = ({ total }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Typography sx={{ mb: 1, color: "#768299" }} variant="body1">
        {t("ConvoyDashboardPage.totalconvoy")}
      </Typography>
      <Typography variant="h4">{total}</Typography>
    </Container>
  );
};

export default ConvoyStatusGuide;
